import { AuthStatus } from '@caresend/types';
import { defineComponent, computed, ref } from 'vue';
import __vue_component__ from '../../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__$3 from '../../../../../../layout/NavBar/components/UserBanner.vue.js';
import { useSessionStore } from '../../../../store/portal/sessionStore.js';
import __vue_component__$2 from '../../../../../../transitions/TransitionFadeOutIn/TransitionFadeOutIn.vue.js';
import __vue_component__$1 from '../../../../../../ui/InteractivePopup/InteractivePopup.vue.js';
import { signOut } from '../../../../../../../database/firebaseConfig/auth.js';
import { getStore } from '../../../../../../../store/helpers/initStore.js';

var script = defineComponent({
    name: 'AuthMenu',
    components: {
        ButtonComponent: __vue_component__,
        InteractivePopup: __vue_component__$1,
        TransitionFadeOutIn: __vue_component__$2,
        UserBanner: __vue_component__$3,
    },
    props: {
        actions: {
            type: Array,
            default: () => [],
        },
    },
    setup(props) {
        const sessionStore = useSessionStore();
        const store = getStore();
        const logout = () => {
            sessionStore.closeAllSessions();
            signOut();
        };
        const isAuthed = computed(() => store.state.auth.authStatus === AuthStatus.COMPLETE);
        const isPopupOpened = ref(false);
        const performAction = (action) => {
            var _a;
            (_a = action.action) === null || _a === void 0 ? void 0 : _a.call(action);
            isPopupOpened.value = false;
        };
        const allAuthActions = computed(() => [
            ...props.actions,
            {
                label: 'Log out',
                icon: 'sign-out-alt',
                action: logout,
            },
        ]);
        return {
            isAuthed,
            logout,
            allAuthActions,
            isPopupOpened,
            performAction,
        };
    },
});

export { script as default };
